/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { Download, ShareButton } from 'components/Download';

export default function AveragePerWeek({
  valueInfo,
  totalsDaysOfWeek,
  totalsDaysOfWeekCost,
}) {
  const intl = useIntl();
  const tableRef = useRef();

  // 🔄 Reordenar los días de la semana en el formato correcto
  const reorderDaysOfWeek = (totals) =>
    [
      totals['1'], // Lunes
      totals['2'], // Martes
      totals['3'], // Miércoles
      totals['4'], // Jueves
      totals['5'], // Viernes
      totals['6'], // Sábado
      totals['7'], // Domingo
    ].filter(Boolean);

  const reorderedTotalsDaysOfWeek = totalsDaysOfWeek
    ? reorderDaysOfWeek(totalsDaysOfWeek)
    : [];
  const reorderedTotalsDaysOfWeekCost = totalsDaysOfWeekCost
    ? reorderDaysOfWeek(totalsDaysOfWeekCost)
    : [];

  // 💰 Formateador de moneda
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <Paper sx={{ p: 2, overflowX: 'hidden', overflowY: 'auto' }} ref={tableRef}>
      {/* 🔹 Etiqueta con título dinámico según el tipo de dato */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Chip
          label={
            valueInfo.kwh
              ? intl.formatMessage({
                  id: 'app.chargeSolar.board.avgPerDayOfWeek.title',
                })
              : intl.formatMessage({
                  id: 'app.chargeSolar.board.avgPerDayOfWeek.titleCost',
                })
          }
          sx={{
            fontWeight: 700,
            backgroundColor: '#730065',
            fontSize: '16px',
            color: 'white',
          }}
        />
        <Box display="flex" alignItems="center" gap={1}>
          <Download
            itemRef={tableRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.avgPerDayOfWeek.title',
            })}
          />
          <ShareButton
            itemRef={tableRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.avgPerDayOfWeek.title',
            })}
          />
        </Box>
      </Box>
      <Box overflow="auto">
        <Table size="medium" sx={{ width: '100%', minWidth: '0' }}>
          <TableHead>
            <TableRow>
              {['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map((day) => (
                <TableCell key={day} align="center">
                  {intl.formatMessage({ id: `app.daysOfWeek.${day}` })}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ padding: '0 !important' }}>
            <TableRow sx={{ height: '0px' }}>
              {(valueInfo.kwh
                ? reorderedTotalsDaysOfWeek
                : reorderedTotalsDaysOfWeekCost
              ).map((row, index) => (
                <TableCell
                  component="th"
                  scope="row"
                  align="center"
                  key={index}
                  sx={{
                    fontSize: '1em',
                    fontWeight: 'bold',
                    backgroundColor: valueInfo.kwh
                      ? row.color_hm
                      : row.color_cost,
                  }}
                >
                  {valueInfo.kwh
                    ? `${row.value} kWh`
                    : formatter.format(row.cost)}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}
